import { Injectable, Injector } from '@angular/core'
import { HttpEvent, HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { finalize, catchError } from 'rxjs/operators'
import { MessagesService } from '../services/messages.service'

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  queueCount: number = 0
  queueEmpty: boolean = true
  constructor(private injector: Injector) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes('api')) {
      return next.handle(req)
    }
    // console.warn("LoaderInterceptor");

    const messagesService = this.injector.get(MessagesService)
    // this.queueEmpty = false;
    this.queueCount++
    if (this.queueCount === 1) {
      setTimeout(() => {
        if (this.queueEmpty === true && this.queueCount > 0) {
          // console.log('showLoading', this.queueEmpty, this.queueCount);
          messagesService.showLoading()
          this.queueEmpty = false
        }
      }, 2000)
    }

    return next.handle(req).pipe(
      catchError((err: any) => {
        // console.log(err)
        // Suppress toast for 400s, for expected 404s on rendered-floorplan (a 404 there
        // simply means the floor has no floorplan data yet), and for the public detail
        // gate's own handled outcomes (429 cooldown, 401/403 expired or out-of-scope token)
        // which surface their own message.
        const suppress =
          err.status === 400 ||
          (err.status === 404 && req.url.includes('rendered-floorplan')) ||
          ((err.status === 429 || err.status === 401 || err.status === 403) && req.url.includes('/PublicReport/'))
        if (!suppress) {
          messagesService.showFailureLoading()
        }
        return throwError(() => err)
      }),
      // delay(4000),
      finalize(() => {
        // console.log(req);
        this.queueCount--
        if (this.queueCount === 0) {
          messagesService.hideLoading()
          // console.log('hideLoading', this.queueCount);
          this.queueEmpty = true
        }
      })
    )
  }
}
